<ds-meta-badge tone="green" [leading]="travelTime | travelTime" trailing="Nonstop" />
